module.exports = require("@bigcommerce/bigpay-client");